import React, { useEffect, useRef } from 'react';

// Components
import TableView from '../../table-view/table-view';
import { NotificationCell } from '../../';

// Redux
import {
  useGetUserNotificationsQuery,
  useAppDispatch,
} from '@breakroom-nx/redux';

function NotificationsPane() {
  const dispatch = useAppDispatch();

  const {
    data: notifications,
    isLoading,
    isSuccess,
    isError,
    error,
    refetch,
  } = useGetUserNotificationsQuery();

  const renderNotifications = () => {
    return notifications?.map((data) => {
      return <NotificationCell notification={data} key={data.uid} />;
    });
  };

  useEffect(() => {
    // console.log('Rendered User Notifications');
    return () => {
      // console.log('Unmounted User Notifications');
    };
  }, []);

  return (
    <TableView
      isLoading={isLoading}
      isSuccess={isSuccess}
      isError={isError}
      error={error}
      noData={!notifications || notifications.length < 1}
      noDataString={'You have no notifications at this time'}
      onRefetch={refetch}
      pb={150}
    >
      {renderNotifications()}
    </TableView>
  );
}

const MemoNotificationsPane = React.memo(NotificationsPane);
export { MemoNotificationsPane };
